import docCookies from "./docCookies"
import { PASSPORT_URL } from "../constants/conf"

export type User = {
  potoken?: string
  ktoken?: string
  userRole?: string
  user_name?: string
  user_type?: string
  oauth_name?: string
  expires?: number | string | Date
  [propName: string]: any
}

interface IEnv {
  user: User
  getUser: () => User
  login: () => void
  logout: () => void
}

const Env: IEnv = {
  user: {},
  getUser() {
    if (Env.user.potoken) {
      return Env.user
    }
    let userInfo = docCookies.parsedCookies() as User
    if (userInfo.potoken) {
      Env.user = userInfo
    }
    return Env.user
  },
  login() {
    window.location.href = `${PASSPORT_URL}/login?redirect=${encodeURIComponent(
      window.location.href
    )}`
  },

  logout() {
    window.location.href = `${PASSPORT_URL}/logout`
  },
}

export default Env
